import {GET, POST} from '../index'

// 获取IP列表
export const getList = (data) => {
  return GET('/system/ip/list', data)
}

// 添加IP
export const addIp = (data) => {
  return POST('/system/ip/add', data)
}

// 删除IP
export const delIp = (data) => {
  return POST('/system/ip/del', data)
}



// WEBPACK FOOTER //
// ./src/api/ip_black/index.js